module.exports = __webpack_public_path__ + "static/media/wedding-min.d44eff3e.jpg";